define.alias("checkout/components/seamless-checkout/feature-banner", "settings/components/seamless-checkout/feature-banner");